export default "__VITE_ASSET__42cc9b5d__"